import { render, staticRenderFns } from "./listInventoies.vue?vue&type=template&id=62719a87&scoped=true"
import script from "./listInventoies.vue?vue&type=script&lang=js"
export * from "./listInventoies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62719a87",
  null
  
)

export default component.exports